import React            from 'react';
import Matrix           from 'pu-react/components/PriceMatrix';
import Rating           from './Rating';
import PriceMatrixCell  from './PriceMatrixCell';
import PriceMatrixDebug from './PriceMatrixDebug';

const PriceMatrix = (props) => {
  const { supplier } = props;
  return (
    <div>
      <div className="price-matrix">
        <div className="body">
          <div className="matrix-wrap">
            <Matrix {...props} matrixCell={PriceMatrixCell} combined="0" tableStripe={false} tableSm />
          </div>
        </div>
      </div>
      <PriceMatrixDebug {...props} />
    </div>
  );
};

export default PriceMatrix;
